import WordpressProvider from './wordpress'

export const WordpressService = new WordpressProvider()
